// @ts-ignore
__webpack_nonce__ = (window as any).__CSP_NONCE__;

export {};
